import { useState } from 'react';
import { Search, Globe, Calculator } from 'lucide-react';

const KEY = 'tpmi_tour_v1';
const STEPS = [
  { icon: Search, title: 'Analyse', body: 'Pick a market, type a ticker and get a five-engine read of current conditions: trade state, what mattered and what to monitor.' },
  { icon: Globe, title: 'Markets', body: 'See the state of every major market at a glance, and compare up to 10 tickers side by side in one table.' },
  { icon: Calculator, title: 'Tools', body: 'Free calculators for position risk, volatility ranges and a conditions checklist you can tick, copy or print.' },
];

export const hasSeenTour = () => Boolean(localStorage.getItem(KEY));

export const GuidedTour = ({ onDone }) => {
  const [step, setStep] = useState(() => (hasSeenTour() ? -1 : 0));
  if (step < 0) return null;
  const close = () => { localStorage.setItem(KEY, 'done'); setStep(-1); onDone?.(); };
  const { icon: Icon, title, body } = STEPS[step];
  const last = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="guided-tour">
      <div className="w-full max-w-sm bg-zinc-950 border border-brand/40 rounded-xl p-6 animate-fade-in" role="dialog" aria-label="Welcome tour">
        <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-4" data-testid="tour-step-indicator">Welcome to Trade PMI · {step + 1} of {STEPS.length}</p>
        <div className="w-10 h-10 rounded-lg bg-brand/10 flex items-center justify-center mb-3"><Icon className="w-5 h-5 text-brand" /></div>
        <h2 className="text-lg font-bold mb-2" data-testid="tour-step-title">{title}</h2>
        <p className="text-sm text-zinc-400 leading-relaxed mb-6">{body}</p>
        <div className="flex items-center justify-between">
          <div className="flex gap-1.5">
            {STEPS.map((s, i) => <span key={s.title} className={`h-1.5 rounded-full transition-all ${i === step ? 'w-5 bg-brand' : 'w-1.5 bg-zinc-700'}`} />)}
          </div>
          <div className="flex gap-3">
            {!last && <button onClick={close} className="text-xs text-zinc-500 hover:text-white" data-testid="tour-skip-btn">Skip</button>}
            <button onClick={() => (last ? close() : setStep(step + 1))} data-testid="tour-next-btn"
              className="bg-brand hover:bg-brand-light text-black text-xs font-bold px-4 py-2 rounded-md transition-colors">
              {last ? 'Get started' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
